import PropTypes from 'prop-types'
import React from 'react'
import SearchInput from 'ui/SearchInput'
import css from './ActivitySearch.module.css'

const ActivitySearch = props => (
  <div className={css.main}>
    <SearchInput
      onChange={props.onSearch}
      defaultValue={props.searchTerm}
      placeholder='Search activity feed...' />
  </div>
)

ActivitySearch.propTypes = {
  onSearch: PropTypes.func.isRequired,
  searchTerm: PropTypes.string
}

ActivitySearch.displayName = 'ActivitySearch'

export default ActivitySearch



// WEBPACK FOOTER //
// ./components/ActivitySearch.js